import styled from 'styled-components'
import { Row, DropdownButton } from 'react-bootstrap'

export const HeaderWrapper = styled.div`
  margin-bottom: 16px;
`

export const AddMemberWrapper = styled.div`
  margin-bottom: 20px;
`

export const MemberButtonWrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: flex-end;
  
  .member-input {
    flex: 1;
  }
  
  .add-button {
    flex-shrink: 0;
  }
  
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
    
    .add-button {
      margin-top: 8px;
    }
  }
`

export const SearchRow = styled(Row)`
  margin: 12px 0 20px 0;
`

export const FilterWrapper = styled.div`
  .input-group {
    height: 28px;
  }
  
  .form-control {
    height: 28px;
    font-size: 0.8rem;
    padding: 0.25rem 0.5rem;
  }
  
  .input-group-text {
    height: 28px;
    padding: 0.25rem 0.5rem;
  }
`

export const LimitMessage = styled.div`
  background: #e3f2fd;
  border: 1px solid #2196f3;
  border-radius: 4px;
  padding: 12px 16px;
  margin-bottom: 16px;
  color: #1976d2;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const TableContainer = styled.div`
  background: #ffffff;
  border: 1px solid #0f73b0;
  border-radius: 4px;
  overflow: hidden;
`

export const TableHead = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 120px;
  background: var(--white);
  color: var(--primary);
  font-weight: 400;
  font-size: 16px;
  padding: 12px 16px;
  border-bottom: 1px solid var(--primary);
`

export const TableRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 120px;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #e0e0e0;
  
  &:last-child {
    border-bottom: none;
  }
`

export const RowValue = styled.span`
  font-size: 14px;
  color: #1f1f1f;
`

export const StatusText = styled.span`
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 16px;
  line-height: 140%;
  letter-spacing: 0%;
`

export const ActionsDropdownButton = styled(DropdownButton)`
  && {
    width: 32px;
    height: 32px;
    padding: 0;
    background: transparent !important;
    border: 1px solid #0066B3 !important;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    
    button {
      width: 100%;
      height: 100%;
      background: transparent !important;
      border: none !important;
      color: #0066B3 !important;
      padding: 0;
      box-shadow: none !important;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      
      &::after {
        display: none !important;
      }
      
      &:hover, &:focus, &:active {
        background: transparent !important;
        border: none !important;
        color: #0066B3 !important;
        box-shadow: none !important;
      }
    }
    
    &:hover, &:focus, &:active {
      background: transparent !important;
      border-color: #0066B3 !important;
    }
  }
`